import { useFetch } from 'bv-hooks';
import fetchCompetition from '../api/fetch_competitions';

export default ({ eventPathId, refreshProps = [] }) => (
  useFetch(() => fetchCompetition({ eventPathId }), refreshProps)
);
